import React, { Component } from 'react';
import config from 'react-global-configuration';

import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class DesignationGroupCertifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      designation_id: this.props.designation_id,
      designation_group_id: this.props.designation_group_id,
      designation_group: this.props.designation_group,
      name_edit: this.props.designation_group.name,
      type_group_edit: this.props.designation_group.type,
      aircraft_model_id_group_edit: this.props.designation_group.aircraft_model_id,
      exception_group_edit: this.props.designation_group.exception,
      certifications_list: [],
      aircraft_models_list: [],
      certification_id: '',
    };
    //bind específico
    this.editGroup = this.editGroup.bind(this);
    this.addCertification = this.addCertification.bind(this);
    this.deleteCertification = this.deleteCertification.bind(this);
    this.deleteRowCertification = this.deleteRowCertification.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    this.setState({designation_id: newProps.designation_id});
    this.setState({designation_group_id: newProps.designation_group_id});
    this.setState({designation_group: newProps.designation_group});
    this.setState({name_edit: newProps.designation_group.name});
    this.setState({type_group_edit: newProps.designation_group.type});
    this.setState({aircraft_model_id_group_edit: newProps.designation_group.aircraft_model_id});
    this.setState({exception_group_edit: newProps.designation_group.exception});
    this.setState({certifications_list: newProps.certifications_list});
    this.setState({aircraft_models_list: newProps.aircraft_models_list});
  }

  editGroup(event) {
    event.preventDefault();
    var datasave = {
      aircraft_model_id: this.state.aircraft_model_id_group_edit,
      exception: this.state.exception_group_edit,
      name: this.state.name_edit,
      type: this.state.type_group_edit,
      id: this.state.designation_group_id,
    };
    var self = this;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao/requisicao/grupo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addCertification(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      certification_id: this.state.certification_id,
      designation_group_id: this.state.designation_group_id,
    };
    var self = this;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao/requisicao/grupo/treinamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteCertification (event) {
    var designation_group_certification_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.deletarTreinamento);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/designacao/requisicao/grupo/treinamento/' + designation_group_certification_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRowCertification(designation_group_certification_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRowCertification(designation_group_certification_id) {
    var data = this.state.designation_group.designation_group_certifications;
    data.map(function(dado, index){
      if (dado.id == designation_group_certification_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }


  render() {
    var self = this;
    return (
<div>
  <hr/>
  <div>
    <h4 className="pull-left">{self.state.designation_group.name}</h4>
    <button className="btn btn-danger btn-sm pull-right" value={self.state.designation_group.id} onClick={this.props.deleteGroup}>
    <i className="fa fa-fw fa-trash"></i></button>
    <div className="clearfix"></div>
  </div>
  <hr/>
  <div className="row">
    <div className="col-md-6">
      <form onSubmit={self.editGroup}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioEditarGrupo.Nome}:</label>
              <input type="text" name='name_edit' className="form-control" placeholder="Nome do grupo" value={self.state.name_edit} onChange={self.handleChange.bind(self, 'name_edit')} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioEditarGrupo.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type_group_edit"
                value={this.state.type_group_edit}
                searchable={true}
                placeholder={'Selecione o tipo'}
                onChange={this.handleSelectChange.bind(this, 'type_group_edit')}
                options={[
                  {value: "E", label: this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioEditarGrupo.opcoesTipo.E},
                  {value: "OU", label: this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioEditarGrupo.opcoesTipo.OU},
                ]}
                required
              />    
            </div>
          </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioEditarGrupo.Frota}:</label>
                <Select
                    className="form-field-name"
                    name="aircraft_model_id_group_edit"
                    value={this.state.aircraft_model_id_group_edit}
                    searchable={true}
                    placeholder={'Selecionar frota'}
                    onChange={this.handleSelectChange.bind(this, 'aircraft_model_id_group_edit')}
                    options={this.state.aircraft_models_list}
                />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioEditarGrupo.Excecao}:</label>
                <br/>
                <Toggle
                    checked={this.state.exception_group_edit}
                    aria-label='No label tag'
                    name="exception_group_edit"
                    onChange={this.handleToggleChange.bind(this, 'exception_group_edit')} />
                </div>
            </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioEditarGrupo.botaoEditarGrupo}</button>
      </form>
    </div>
    <div className="col-md-6">
      <form onSubmit={self.addCertification}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioIncluirTreinamento.Treinamento}:</label>
              <Select
                className="form-field-name"
                name="certification_id"
                value={this.state.certification_id}
                searchable={true}
                placeholder={'Selecionar treinamento'}
                onChange={this.handleSelectChange.bind(this, 'certification_id')}
                options={this.state.certifications_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <br/>
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formularioIncluirTreinamento.botaoIncluirTreinamento}</button>
          </div>
        </div>
      </form>
      <table className="table">
        <thead>
          <tr>
            <th>
              {this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.tabela.Treinamento}
            </th>
            <th>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.tabela.Acoes}</th>
          </tr>
        </thead>
        {Object.keys(self.state.designation_group.designation_group_certifications).map(function(k) {
          return (
            <tbody id="treinamentos">
              <tr>
                <td>
                  {self.state.designation_group.designation_group_certifications[k].certification.name}
                </td>
                <td>
                  <button className="btn btn-sm btn-danger" value={self.state.designation_group.designation_group_certifications[k].id} onClick={self.deleteCertification}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          );
        })}
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default DesignationGroupCertifications;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationGroupCertifications.js